module.exports = __webpack_public_path__ + "media/images/meta/xponential/apple-touch-icon-297d824253e5630c2417d8035223b13a.png";